module.exports = __webpack_public_path__ + "static/media/shop-2.685eeb44.jpg";